import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import { RouterProvider } from "react-router-dom";
import { routes } from "./routes";
import "./App.css";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { setupAuthListener } from "./api/apiUtils";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

export const App = () => {
  const params = new URLSearchParams(window.location.search);
  const id = params.get("id");

  if (id) {
    localStorage.setItem("__Iplot_admin_access_", id);

    params.delete("id");
    const newUrl =
      window.location.pathname +
      (params.toString() ? `?${params.toString()}` : "");
    window.history.replaceState({}, "", newUrl);
  }

  const dispatch = useDispatch();

  useEffect(() => {
    setupAuthListener(dispatch);
  }, [dispatch]);

  return (
    <QueryClientProvider client={queryClient}>
      <Toaster
        toastOptions={{
          style: {
            zIndex: 999999999,
          },
        }}
      />
      <RouterProvider router={routes} />
    </QueryClientProvider>
  );
};
